const state = {
  records:new Array,
  users:new Array,
  companies:new Array,
}
const mutations = {
SAVE_RECORDS (state, payload) {
  state.records = payload
},
APPEND_RECORDS (state, payload) {
  state.records = state.records.concat(payload)
},
ADD_RECORD (state, payload) {
  state.records.push(payload)
},
SAVE_COMPANIES(state, payload) {
  state.companies = payload
},
ADD_COMPANY(state, payload){
  state.companies.push(payload)
},
UPDATE_RECORD(state, payload) {
 const record = state.records.findIndex(rec => rec.id === payload.id)
 const fields = record > -1 ? state.records[record].acf : false
 if(payload.prop === 'new_routes') {
 try{
window.console.log('try', fields)
  !fields.routes 
  ? fields.routes = [payload.data]
  : fields['routes'].push(payload.data)
 }catch(err){
window.console.log('catch')
   if(err){
     fields['routes'] = [payload.data]
   }
 }
 }else {
  fields
  ? fields[payload.prop] =  payload.data
  : window.console.log('err')
 }

},
SAVE_USERS(state, payload) {
  state.users = payload
},
ADD_NEW_USER(state, payload){
  state.users.push(payload)
},
DELETE_RECORD(state, payload) {
  const match = state.records.findIndex(item => item.id === parseInt(payload))
  match > -1
  state.records.splice(match, 1)
},
}
export default {
state,
mutations
}